module.exports = __webpack_public_path__ + "static/media/Popup_EnvironmentPresets.a08d556d.png";